import { notNull } from "@/utils/helpers";

// With Cache Components, Next keeps recently left pages mounted inside a hidden
// <Activity>, which React hides with an inline `display: none !important`.
// These lookups skip those pages, so a hidden copy of an id or selector never
// wins over the page the user is on.
export const isHiddenByActivity = (element: Element) =>
  element instanceof HTMLElement &&
  element.style.getPropertyValue("display") === "none" &&
  element.style.getPropertyPriority("display") === "important";

export const isInHiddenPage = (element: Element | null): boolean =>
  notNull(element) &&
  (isHiddenByActivity(element) || isInHiddenPage(element.parentElement));

export const queryActivePageAll = <E extends Element = Element>(
  selector: string
): E[] =>
  Array.from(document.querySelectorAll<E>(selector)).filter(
    (element) => !isInHiddenPage(element)
  );

export const queryActivePage = <E extends Element = Element>(
  selector: string
): E | null => queryActivePageAll<E>(selector)[0] ?? null;

export const getActivePageElementById = (id: string): HTMLElement | null =>
  queryActivePage<HTMLElement>(`[id="${id.replace(/["\\]/g, "\\$&")}"]`);
